import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Stripe from 'react-stripe-checkout';

import Modal from '../Modal';
import { toCurrency } from '../../util/helpers';
import magic from '../../util/magic';
import EditField from '../Forms/EditField';
import Checkbox from '../Forms/Checkbox';
import { routes } from '../../routes';

const mapStore = ({ user }) => ({ user });

class StripeCheckout extends Component {
  static propTypes = {
    amount: PropTypes.number,
    disabled: PropTypes.bool,
    user: PropTypes.object,
    pay: PropTypes.func,
  };

  state = {
    showModal: false,
    overrideNotes: '',
    understandRefund: false,
  };

  renderStripeButton = (message) => {
    const { amount, disabled, user, pay, ...props } = this.props;
    const { understandRefund } = this.state;

    return (
      <Stripe
        stripeKey={window.env.REACT_STRIPE_KEY}
        email={user.email}
        amount={amount * 100}
        token={(token) => this.setState({ showModal: false }, () => pay(token.id))}
        {...props}
      >
        <button type="button" className="btn btn-primary" disabled={disabled || !understandRefund}>
          {message}
        </button>
      </Stripe>
    );
  };

  render() {
    const { amount, disabled, user, pay } = this.props;
    const { showModal, overrideNotes, understandRefund } = this.state;
    const isImpersonating = window.__IMPERSONATING__;

    if (amount <= 0) {
      return (
        <button type="button" className="btn btn-primary" disabled={disabled} onClick={() => pay()}>
          Submit
        </button>
      );
    }

    return (
      <Fragment>
        <button
          type="button"
          className="btn btn-primary"
          disabled={disabled}
          onClick={() => this.setState({ showModal: true })}
        >
          Enter Payment Information
        </button>
        <Modal show={showModal} onHide={() => this.setState({ showModal: false })} title="Approve Payment">
          <Modal.Body>
            {user.cardLastFour && (
              <p>
                Would you like to pay {toCurrency(amount)} with your card ending in {user.cardLastFour}?
              </p>
            )}
            {isImpersonating && (
              <EditField
                block
                label="Extra notes (if using Admin override)"
                as="textarea"
                name="overrideNotes"
                onChange={({ target }) => this.setState({ overrideNotes: target.value })}
                value={overrideNotes}
              />
            )}
            <Checkbox
              name="retake"
              label={
                <span>
                  I have reviewed and understand the{' '}
                  <a href={routes.wordPress.refundPolicy} target="_blank">
                    refund policy
                  </a>
                </span>
              }
              checked={understandRefund}
              onChange={() => this.setState({ understandRefund: !understandRefund })}
            />
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex flex-grow-1">
              <div className="flex-grow-1">
                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showModal: false })}>
                  Cancel
                </button>
              </div>
              {this.renderStripeButton(!user.cardLastFour ? 'Enter Payment Information' : 'Use Different Card')}
              {isImpersonating && (
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={() =>
                    this.setState({ showModal: false }, () => pay(magic.adminOverrideToken, { overrideNotes }))
                  }
                >
                  Admin Override
                </button>
              )}
              {user.cardLastFour && (
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  disabled={!understandRefund}
                  onClick={() => this.setState({ showModal: false }, pay)}
                >
                  Pay
                </button>
              )}
            </div>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

export default connect(mapStore)(StripeCheckout);
